const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/checklist-library/$systemChecklistId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { libraryDefaultsSchema } from "@/components/checklist-library/library-defaults-fields";
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { SystemChecklistDetail } from "@/types/api/checklist-library";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/checklist-library/$systemChecklistId")({
  beforeLoad: args => requirePermission(Permissions.ChecklistLibrary.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const metadataSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
  regulatoryReference: z.string().optional(),
  recommendedFrequency: z.string().optional(),
  industries: z.array(z.object({
    industryKey: z.string(),
    includeInStarterPack: z.boolean(),
    displayOrder: z.number()
  })),
  defaults: libraryDefaultsSchema
});
type MetadataFormValues = z.infer<typeof metadataSchema>;

/**
 * One catalog item: metadata + industry tags + copy-down defaults (PUT),
 * the immutable version history (view / download each version), export
 * bundles for environment promotion, and the active kill switch.
 */